import styled from 'styled-components'
import { ResponsiveBox } from '@usap/uicomponents'

const BoxItemContainer = styled(ResponsiveBox)`
  width: 200px;
  justify-content: center;
  align-items: center;
  display: inline-block;
  flex-shrink: 0;
  margin: 0 3px;
  @media (max-width: 768px) {
    width: 180px;
  }
`

export default BoxItemContainer
